// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__BIFCI","mail":"footer_mail__cm8YN"};